export default "__VITE_ASSET__BA5XpbgC__"